import Vue from 'vue';
import VueRouter from 'vue-router';
import Store from './store';
Vue.use(VueRouter);
const router = new VueRouter({
    mode: 'history',
    base: '/',
    routes: [
        {
            path: '/',
            component: () => import('./homePage/app.vue'),
        },
        {
            path: '/aboutISOC',
            component: () => import('./aboutxiehui/main.vue'),
        },
        {
            path: '/ifmDesc',
            component: () => import('./aboutxiehui/ifmDesc.vue'),
        },
        {
            path: '/ifmInChina',
            component: () => import('./aboutxiehui/ifmInChina.vue'),
        },
        {
            path: '/ifmLishihui',
            component: () => import('./aboutxiehui/ifmLishihui.vue'),
        },
        {
            path: '/ifmGrop',
            component: () => import('./aboutxiehui/grop.vue'),
        },
        {
            path: '/ifmExam',
            component: () => import('./ifmExam/main.vue'),
        },
        {
            path: '/qualificationTest',
            component: () => import('./ifmExam/qualificationTest.vue'),
        },
        {
            path: '/manageSystem',
            component: () => import('./ifmExam/manageSystem.vue'),
        },
        {
            path: '/makeup',
            component: () => import('./ifmExam/makeup.vue'),
        },
        {
            path: '/industryEvaluation',
            component: () => import('./ifmExam/industryEvaluation.vue'),
        },
        {
            path: '/ifmMember',
            component: () => import('./ifmMember/main.vue'),
        },
        {
            path: '/authorizedUnit',
            component: () => import('./authorizedUnit/main.vue'),
        },
        
        {
            path: '/activityDetail',
            component: () => import('./ifmMember/activityDetail.vue'),
        },
        {
            path: '/networks',
            component: () => import('./networks/main.vue'),
        },
        {
            path: '/certificateQuery',
            component: () => import('./certificateQuery/main.vue'),
        },
        {
            path: '/cjs',
            component: () => import('./certificateQuery/cjSearch.vue'),
        },
        {
            path: '/zss',
            component: () => import('./certificateQuery/zsSearch.vue'),
        },
        {
            path: '/activityDetail',
            component: () => import('./ifmMember/activityDetail.vue'),
        },
        {
            path: '/joinActivity',
            component: () => import('./ifmMember/joinActivity.vue'),
        },
        {
            path: '/course',
            component: () => import('./course/app.vue'),
        },
        {
            path: '/courseDetail',
            component: () => import('./course/detail.vue'),
        },
        {
            path: '/ebookLearning',
            component: () => import('./course/ebookLearning.vue'),
        },
        {
            path: '/learningCourse',
            component: () => import('./course/learning.vue'),
        },
        {
            path: '/info',
            component: () => import('./infoList/list.vue'),
        },
        {
            path: '/infoDetail',
            component: () => import('./infoList/detail.vue'),
        },
        {
            path: '/contact',
            component: () => import('./contact/app.vue'),
        },
        {
            path: '/zhinan',
            component: () => import('./zhinan/app.vue'),
        },
        {
            path: '/certificate',
            component: () => import('./zhengshu/app.vue'),
        },
        {
            path: '/detail',
            component: () => import('./infoList/detail.vue'),
        },
        {
            path: '/myexams',
            component: () => import('./examList/app.vue'),
        },
        {
            path: '/exam',
            component: () => import('./exam/app.vue'),
        },
        {
            path: '/examAttachment',
            component: () => import('./exam/attachment.vue'),
        },
        {
            path: '/simulationPractice',
            component: () => import('./simulationPractice/app.vue'),
        },
        {
            path: '/login',
            component: () => import('./registerAndLogin/login.vue'),
        },
        {
            path: '/examlogin',
            component: () => import('./registerAndLogin/examlogin.vue'),
        },
        {
            path: '/reset',
            component: () => import('./registerAndLogin/resetPassword.vue'),
        },
        {
            path: '/register',
            component: () => import('./registerAndLogin/register.vue'),
        },
        {
            path: '/sqjg',//授权机构列表
            component: () => import('./sqjgList/app.vue'),
        },
        {
            path: '/enrollStudent',
            component: () => import('./enrollStudent/main.vue'),
        },
        {
            path: '/authorg',
            component: () => import('./authorg/main.vue'),
        },
        {
            path: '/searchScore',//成绩查询
            component: () => import('./achievement/searchScore.vue'),
        },
        {
            path: '/searchCer',//查询证书
            component: () => import('./achievement/searchCer2.vue'),
        },
        {
            path: '/videoList',
            component: () => import('./exam/videoList.vue'),
        },
        {
            path: '/result',//查询证书结果页
            component: () => import('./achievement/result.vue'),
        },
        {
            path: '/applyExam',
            component: () => import('./personalInfo/applyExam.vue'),
        },
        {
            path: '/profile',
            component: () => import('./profile/app.vue'),
        },
        {
            path: '/zfb',
            component: () => import('./zfbApply.vue'),
        },
        {
            path: '/check',
            component: () => import('./registerAndLogin/check.vue'),
        },
        {
            path: '*',
            component: () => import('./404.vue'),
        }
    ],
});
router.beforeEach(async (to, from, next) => {
    if(to.path.indexOf('/videoList') > -1){
        next();
        return false;
    }
    if(localStorage.getItem('ifm_token')&& !Store.state.userInfo.id){
     await Store.dispatch('UPDATE_USERINFO',window.$http);
    }
    const needVerLoginPageArr = ['/course','/courseDetail','/learningCourse','/simulationPractice'];
    const examNeedVerLoginPageArr = ['/myexams','/studentExam','/applyExam']
    const toPath = to.path.split('?')[0];
    if(to.path === '/register'&&localStorage.getItem('ifm_token')){
        next('/');
    }
    else if(!localStorage.getItem('ifm_token')&&needVerLoginPageArr.indexOf(toPath)>-1){
        next('/login');
    }
    else if(!localStorage.getItem('ifm_token')&&examNeedVerLoginPageArr.indexOf(toPath)>-1){
        next('/examlogin');
    }
    else{
        next();
    }
    
});
export default router;
